export const activeModalId = (state) => state?.modal?.activeModal?.id;
export const activeModalContext = (state) => state?.modal?.activeModal?.context;
export const activeModalVisible = (state) =>
  state?.modal?.activeModal?.visible || false;

export const modalIsActive = (state) => (id) => activeModalId(state) === id;
export const modalIsVisible = (state, id) =>
  activeModalId(state) === id && activeModalVisible(state);
